module.exports = __webpack_public_path__ + "caracol-large-2.jpg?ec5b06f0e92ec32bbd6579b0d30c6003";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/caracol-large-2.jpg
// module id = 168
// module chunks = 0